import ClickAndCollectStoreMapView from './ClickAndCollectStoreMapView';

export default ClickAndCollectStoreMapView;
